const home: Record<string, string> = {
  // Hero
  'hero.eyebrow': '型式批准 · Homologation · 法规合规',
  'hero.title': '您值得信赖的全球市场准入合作伙伴',
  'hero.intro': '协助制造商、测试实验室、政府单位和第三方机构在180多个国家完成产品认证——更快速、全程可追踪、省心无忧。',
  'hero.cta1': '开始合作',
  'hero.cta2': '了解我们的服务',
  'stats.0.label': '年行业经验',
  'stats.1.label': '支持的国家',
  'stats.2.label': '已交付证书',
  'stats.3.label': '一次通过率',

  // About
  'about.eyebrow': '关于我们',
  'about.title': '关于 Gaudi Enterprises 全球合规',
  'about.p1': '在巴西，Bracert Certificações 是 Bracert 认证机构的授权商务代理。该机构是经 ANATEL 授权的<strong>指定认证机构（OCD）</strong>，同时也是经 INMETRO 认可的<strong>产品认证机构（OCP）</strong>。',
  'about.p2': 'Gaudi Enterprises 为全球的制造商、测试实验室和第三方机构提供<strong>型式批准</strong>、<strong>认证（Homologation）</strong>和<strong>法规合规</strong>服务。我们同时是墨西哥 NOM 产品认证机构（OCP）SEATSA，以及巴西 ANATEL（OCD）和 INMETRO 认证机构 Bracert Certificações 的商务代理。',
  'about.p3': '我们的法规专家团队在通信产品国际认证领域拥有 20 多年经验，涵盖消费电子、家用电器、企业终端、工业物流、汽车、物联网和海事等行业。',
  'about.points.0': '全球市场准入（GMA）策略与预审方案咨询',
  'about.points.1': '审批过程中高效顺畅的项目执行',
  'about.points.2': '证书有效期跟踪与续期提醒',
  'about.points.3': '跟踪全球法规更新及其对产品的影响',
  'about.points.4': '研究新兴技术的市场准入可行性',
  'about.imgAlt': '认证文件工作台',
  'about.imgTitle': 'GaudiEnt 认证服务',

  // Certification
  'cert.eyebrow': '为什么选择我们',
  'cert.title': 'Gaudi Enterprises 是谁',
  'cert.intro': '在巴西，该机构是经 ANATEL 授权的指定认证机构（OCD），同时也是经 INMETRO 认可的产品认证机构（OCP）。我们Gaudi是Bracert Certificações认证机构在中国的授权商务代理。',
  'cert.heading': '巴西产品认证的两大支柱',
  'cert.pillar.0.role': '指定认证机构（OCD）',
  'cert.pillar.0.points.0': '经 ANATEL 授权，评估须强制认证的电信产品。',
  'cert.pillar.0.points.1': '签发技术符合性证书。',
  'cert.pillar.1.role': '产品认证机构（OCP）',
  'cert.pillar.1.points.0': '经 INMETRO 认可，依据技术标准对产品进行认证。',
  'cert.pillar.1.points.1': '基于质量、安全和性能提供产品认证。',

  // Services
  'services.eyebrow': '我们的服务',
  'services.title': '全方位合规服务',
  'services.0.title': '型式批准与认证（Homologation）',
  'services.0.desc': '为 180 多个市场的无线电、电信和 EMC 产品提供各国型式批准与认证（Homologation）的全流程管理。',
  'services.1.title': '产品认证与法规咨询',
  'services.1.desc': '针对您的上市计划，提供 GMA 策略预审方案、差距分析和认证路线图。',
  'services.2.title': '证书维护',
  'services.2.desc': '有效期跟踪、续期提醒和变更通知，确保证书不会失效。',
  'services.3.title': '法规监测',
  'services.3.desc': '持续关注全球法规更新，并评估其对您产品组合的影响。',
  'services.4.title': '本地代表服务',
  'services.4.desc': '在监管机构要求本地实体的国家，提供当地代表和进口商备案服务。',
  'services.5.title': '新兴技术研究',
  'services.5.desc': '针对 UWB、Wi-Fi 7、卫星物联网、V2X 等新技术开展全球准入可行性研究。',

  // Categories
  'categories.eyebrow': '行业领域',
  'categories.title': '服务类别',
  'categories.imgTitle': '{{name}}认证',
  'categories.0.name': '消费电子',
  'categories.0.count': '1,240 个项目',
  'categories.1.name': '家用电器',
  'categories.1.count': '860 个项目',
  'categories.2.name': '汽车与车联网（V2X）',
  'categories.2.count': '410 个项目',
  'categories.3.name': '工业与物联网',
  'categories.3.count': '720 个项目',
  'categories.4.name': '企业终端',
  'categories.4.count': '530 个项目',
  'categories.5.name': '海事与卫星',
  'categories.5.count': '180 个项目',

  // Onboarding
  'onboarding.eyebrow': '服务流程',
  'onboarding.title': '四步完成客户入驻',
  'onboarding.0.title': '初步沟通',
  'onboarding.0.desc': '向专属法规专家说明您的产品规格、目标市场和上市时间表。',
  'onboarding.1.title': '合规路线图',
  'onboarding.1.desc': '获得按国家划分的方案，包含要求、周期和透明报价。',
  'onboarding.2.title': '资料准备与测试',
  'onboarding.2.desc': '我们为您准备申报资料、协调本地测试，并与认证机构沟通。',
  'onboarding.3.title': '批准与后续服务',
  'onboarding.3.desc': '证书交付至您的账户，并持续提供续期跟踪和法规提醒。',
  'onboarding.cta': '开始您的客户入驻',

  // CTA + footer
  'cta.imgAlt': '全球合作背景',
  'cta.title': '受到全球监管机构、实验室和合作伙伴的信赖',
  'cta.text': '我们让您的认证流程全程可追踪，并帮助您的业务领先于每一次法规变化。',
  'cta.link': '查看支持国家的完整列表',
  'footer.title': '联系我们获取支持',
  'contact.0.label': 'WhatsApp',
  'contact.1.label': '手机',
  'contact.2.label': '电子邮件',
  'contact.3.label': '微信',
  'footer.address': '注册地址',
  'footer.directions': '获取路线',
  'footer.phone': '电话 / WhatsApp',
  'footer.copy': '© 2026 GaudiEnt 全球合规。保留所有权利。',
  'footer.tagline': '型式批准 · Homologation · 法规合规 · 产品认证',
};
export default home;
